<main class="main-page full-height overflow-hidden" fxLayout="column">
  <div class="top-header">
    <app-header [showSideBarMenu]="false" [showClientName]="false"></app-header>
  </div>

  <div class="dashboard-content full-height overflow-hidden" style="padding: 4rem" fxLayout="column">
    <div class="dashboard-wrapper full-height report-section" fxLayout="row" style="background: none">
      <div fxLayout="row" class="full-width">
        <div class="welcome-contnet" fxLayoutAlign="left center">
          <div class="hero-text hero-text-full">
            <h1>
              <span>{{ constants.LABELS.welcome }} </span>
            </h1>
            <p>{{constants.ERROR.MESSAGES.DESCRIPTION}}</p>
          </div>
        </div>
        <div class="welcome-buttons" fxLayout="column" fxLayoutAlign="Left Left" style="min-height: 150px; overflow: auto;justify-content: flex-start!important;">
          @if (isLoading) {
            <div class="center loader" style="margin: 100px auto;">
              <img src="../../../../assets/images/loader.gif" alt="loader" class="loader-img" />
            </div>
          }
          @if (listOfParentClients.length > 0) {
            <section>
              <h4 class="text-label">{{constants.LABELS.combinedReport}}</h4>
              <div class="list-of-report">
                <div class="input-group">
                  <div fxLayout="row layout-wrap" fxLayoutAlign="start start">
                    @for (p of listOfParentClients; track p) {
                      <div fxFlex="30">
                        <mat-checkbox [checked]="p.checked" (change)="clickedCombinedReport($event,p)">
                          {{p.clientName}}
                        </mat-checkbox>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </section>
          }
          @if (listOfParentClients.length > 0) {
            <div class="or text-accent"><span>{{constants.LABELS.or}}</span>
          </div>
        }
        @if (listOfClients.length > 0) {
          <section>
            <h4 class="text-label">{{constants.LABELS.individualClient}}</h4>
            <div class="list-of-report">
              <div class="input-group">
                <div fxLayout="row layout-wrap" fxLayoutAlign="start start">
                  @for (c of listOfClients; track c) {
                    <div fxFlex="30">
                      <mat-checkbox [checked]="c.checked" (change)="checkedIndividualClientReport($event,c)">
                        {{c.clientName}}
                      </mat-checkbox>
                    </div>
                  }
                </div>
              </div>
            </div>
          </section>
        }
        @if (showDiversifiedClients) {
          <div class="or text-accent"><span>{{constants.LABELS.or}}</span></div>
        }
        @if (showDiversifiedClients) {
          <section>
            <h4 class="text-label">Report by Diversified Client</h4>
            <div class="input-group">
              <div fxLayout="row layout-wrap" fxLayoutAlign="start start">
                @for (d of diversifiedClientList; track d) {
                  <div fxFlex="30">
                    <mat-checkbox [checked]="d.checked" (change)="checkedDiversifiedClient($event,d)">
                      {{d.subGroupName}}
                    </mat-checkbox>
                  </div>
                }
              </div>
            </div>
          </section>
        }
        @if (showError) {
          <div>
            <h6>{{constants.ERROR.MESSAGES.NOCLIENTS}}</h6>
          </div>
        }
      </div>
    </div>
  </div>
</div>

<div class="bottom-panel text-center">

  @if (!showError) {
    <div class="btn-group flex justify-center">
      @if (showBackIcon) {
        <button mat-button class="secondary-btn sm-btn" (click)="backToAppSelection()"> Back to
        Home</button>
      }
      <button mat-button class="primary-btn sm-btn" (click)="saveReportDetails()"
      [disabled]="isDisabledButton()">{{constants.LABELS.continueReport}}</button>
    </div>
  }
</div>
<div class="footer text-center main-footer">
  <app-footer></app-footer>
</div>
</main>


